module.exports = __webpack_public_path__ + "img/2.d597e881.png";